export const assetMap = Object.freeze({
  BTC: 'Bitcoin',
  ETH: 'Ethereum'
})

export const hiddenAssets = Object.freeze({
  SANS: 'SANS',
  UAHX: 'UAHX'
})

export function filterHiddenAssets (assets) {
  if (Array.isArray(assets)) {
    return assets.filter(item => item.asset !== hiddenAssets.SANS && item.asset !== hiddenAssets.UAHX)
  } else if (typeof assets === 'object') {
    Object.entries(hiddenAssets).forEach(([key, value]) => {
      delete assets[value]
    })
    return assets
  }
}



// WEBPACK FOOTER //
// ./src/js/const/asset_map.js